import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";

export class PartnerConnectIsHistoryComplete extends Decision {
    public evaluate(): Exit {
        return (PartnerConnectManager.isHistoryMode() && !PartnerConnectManager.isHistoryPending()) ? Exit.True : Exit.False;
    }
}
